<template>
  <gmap-map
    ref="map"
    :center="center"
    :zoom="13"
  >
    <gmap-marker
      :icon="locationIcon"
      :position="center"></gmap-marker>
    <store-marker
      v-for="store in stores"
      :key="`store-${store.ID}`"
      :store="store"
    ></store-marker>
  </gmap-map>
</template>

<script>
import StoreMarker from './store-marker'

export default {
  props: [
    'location',
    'stores',
    'apiKey',
  ],
  components: {
    'store-marker': StoreMarker,
  },
  data: function() {
    return {
      map: null,
      locationMarker: null,
      locationIcon: "https://maps.google.com/mapfiles/ms/icons/green-dot.png",
      markers: [],
    }
  },
  computed: {
    center () {
      return {
        lat: this.latitude,
        lng: this.longitude,
      }
    },
    latitude () {
      return this.location.latitude
    },
    longitude () {
      return this.location.longitude
    },
  },
  watch: {
    stores () {
      this.fitMap()
    },
  },
  methods: {
    fitMap: function () {
      var locationLatLng = new google.maps.LatLng(this.latitude, this.longitude)

      var latLngs = [
        locationLatLng,
      ]

      for (var store in this.stores) {
        latLngs.push(
        new google.maps.LatLng(this.stores[store].store_latitude, this.stores[store].store_longitude)
        )
      }

      var latLngBounds = new google.maps.LatLngBounds();
      latLngs.forEach(function (latLng) {
        latLngBounds.extend(latLng)
      })

      this.$refs.map.fitBounds(latLngBounds);
    },
  }

}
</script>
